import { Grid, useEventCallback } from '@mui/material';
import Buttons from 'shell/components/shared/certification-civil-status/certification-form/buttons';
import { CertificateCrumbs } from 'civil-status/constants/breadcrumb';
import { Form, Formik } from 'formik';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate } from 'react-router-dom';
import {
  AccountholderFormVM,
  ApplicantFormVM,
  CertificationFormVM,
} from 'civil-status/view-models/document-birth-form';
import FormDetail from 'shell/components/shared/certification-civil-status/certification-form';
import { useMemo, useState } from 'react';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { CertificationStep } from 'civil-status/constants/certification-step';
import createSchema from './schema';
import { CommonFrontOfficeCrumbs } from 'front-office/constants/breadcrumb';

export const initialApplicant: ApplicantFormVM = {
  fiscalCode: '',
  surname: '',
  withoutSurname: false,
  name: '',
  withoutName: false,
  gender: '',
  birthDate: null,
  municipality: null,
  isForeign: false,
  foreignState: null,
  documentNumber: '',
  documentIssuedDate: null,
  foreignMunicipality: null,
  isForeignDocument: false,
  municipalityDocument: null,
  foreignStateDocument: '',
};

export const intialAccountholder: AccountholderFormVM = {
  reasonRelease: '',
  fiscalCode: '',
  surname: '',
  withoutSurname: false,
  name: '',
  withoutName: false,
  gender: '',
  birthDate: null,
  sameAsApplicant: true,
};

interface CertificationFormPageProps {
  isFromFrontOffice?: boolean;
}

export default function CertificationFormPage({
  isFromFrontOffice = false,
}: CertificationFormPageProps): React.ReactElement {
  const baseUrl = useMemo(() => {
    if (isFromFrontOffice) {
      return 'sportello';
    }

    return 'stato-civile';
  }, [isFromFrontOffice]);

  const navigate = useNavigate();

  const [active, setActive] = useState<CertificationStep>(CertificationStep.ApplicantAccountholder);

  const { userProfile } = useUserProfile();

  const cashManagement = userProfile?.datiLogin?.profile?.servizio?.gestioneCassa || '';

  const isDisabled = cashManagement !== 'S';

  const onNext = useEventCallback(() => {
    setActive(active + 1);
  });

  const onBack = useEventCallback(() => {
    if (!active) {
      return;
    }
    setActive(active - 1);
  });

  const handleExit = useEventCallback(() => {
    navigate(`/${baseUrl}`);
  });

  const validationSchema = useMemo(() => {
    return createSchema(active);
  }, [active]);

  return (
    <>
      <Breadcrumbs
        items={[
          ...(isFromFrontOffice ? CommonFrontOfficeCrumbs : CertificateCrumbs),
          { name: 'Certificazione Stato Civile', path: `/${baseUrl}/certificazione` },
        ]}
        base={baseUrl}
      />
      <Formik
        initialValues={
          {
            applicant: initialApplicant,
            accountholder: intialAccountholder,
            certificate: null,
            selectedCertificate: 'COPIACONFORME',
            file: undefined,
            raw: [],
            rawTiff: '',
            copies: '1',
            timber: '',
            timberFreeText: '',
            reason: '',
            chosenDocument: null,
            flagCarta: isDisabled,
            flagInternal: isDisabled,
          } as CertificationFormVM
        }
        validationSchema={validationSchema}
        onSubmit={onNext}
        validateOnMount
        validateOnChange
        validateOnBlur
      >
        {({ values }) => (
          <Form>
            <Grid container spacing={1}>
              {active === CertificationStep.Visualize &&
              !values.chosenDocument?.isAnsc ? undefined : (
                <Grid item xs={12} md={2}>
                  <Buttons handleExit={handleExit} handleStep={setActive} activeStep={active} />
                </Grid>
              )}

              <Grid
                item
                xs={12}
                md={
                  active === CertificationStep.Visualize && !values.chosenDocument?.isAnsc ? 12 : 10
                }
              >
                <FormDetail step={active} onBack={onBack} onNext={onNext} />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
}

CertificationFormPage.displayName = 'home page component';
